import InfoModal from '../../../shared/components/InfoModal';
import NuevaSolicitudModal from '../NuevaSolicitudModal';
import ResponderSolicitudModal from '../ResponderSolicitudModal';
import SinAlternativaModal from '../SinAlternativaModal';
import AsignarAtClienteModal from '../AsignarAtClienteModal';
import NotaInternaModal from '../NotaInternaModal';
import DetalleSolicitudModal from '../DetalleSolicitudModal';
import { getAsignarAtClienteModalTitle } from '../../actions';
import { getEstadoId, getDetalleModalTitle } from '../../utils';

const STATIC_MODALS = {
    new: {
        title: 'Nueva solicitud de alternativa',
        width: 'md',
        Component: NuevaSolicitudModal,
    },
    responder: {
        title: 'Responder solicitud',
        width: 'md',
        Component: ResponderSolicitudModal,
    },
    sin_alternativa: {
        title: 'Sin alternativa',
        width: 'md',
        Component: SinAlternativaModal,
    },
    asignar: {
        width: 'sm',
        Component: AsignarAtClienteModal,
    },
    nota_interna: {
        title: 'Añadir nota interna',
        width: 'sm',
        Component: NotaInternaModal,
    },
};

const SolicitudAlternativasModals = ({
    modal,
    closeModal,
    onUpdateRow,
    onNewCreated,
}) => {
    if (!modal.type) {
        return null;
    }

    if (modal.type === 'detalle' && modal.item) {
        return (
            <InfoModal
                key={`detalle-${modal.item.id}-${modal.intent}`}
                state
                title={getDetalleModalTitle(
                    getEstadoId(modal.item),
                    modal.intent,
                )}
                content={
                    <DetalleSolicitudModal
                        currentItem={modal.item}
                        detalleIntent={modal.intent}
                        onClose={closeModal}
                        onSolicitudUpdated={onUpdateRow}
                    />
                }
                width="md"
                onClose={closeModal}
            />
        );
    }

    const config = STATIC_MODALS[modal.type];
    if (!config) {
        return null;
    }

    const { Component, title: staticTitle, width } = config;
    const title =
        modal.type === 'asignar'
            ? getAsignarAtClienteModalTitle(modal.item?.crafted_by)
            : staticTitle;

    if (modal.type === 'new') {
        return (
            <InfoModal
                key="modal-new"
                state
                title={title}
                content={
                    <Component
                        onClose={closeModal}
                        handleNewSolicitudCreated={onNewCreated}
                    />
                }
                width={width}
                onClose={closeModal}
            />
        );
    }

    return (
        <InfoModal
            key={`${modal.type}-${modal.item?.id}`}
            state
            title={title}
            content={
                <Component
                    currentItem={modal.item}
                    onClose={closeModal}
                    onSolicitudUpdated={onUpdateRow}
                />
            }
            width={width}
            onClose={closeModal}
        />
    );
};

export default SolicitudAlternativasModals;
